import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import Loader from "../Loader/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTheme } from "styled-components";
import CircularButton from "../CircularButton/CircularButton";
import resetOrientation from "reset-image-orientation";

const onChange = (setUploading, setImageUrl, e, folder) => {
  setUploading(true);
  let filename = "";
  let contentType = "";
  let upFile = e.target.files[0];
  filename = upFile.name;
  contentType = upFile.type;
  if (contentType === "image/jpeg" || contentType === "image/jpg") {
    resetOrientation(e.target.files[0], base64 => {
      var base64EncodedImageString = base64.replace(
        /^data:image\/\w+;base64,/,
        ""
      );
      var imageBuffer = new Buffer(base64EncodedImageString, "base64");
      fetch(
        "https://us-central1-kids-qualitytime.cloudfunctions.net/upload_file/url",
        {
          method: "POST",
          headers: {
            Accept: "application/json"
          },
          body: JSON.stringify({
            filename,
            contentType,
            folder
          })
        }
      )
        .then(res => res.json())
        .then(res => {
          fetch(res.url, {
            method: "PUT",
            headers: {
              "Content-Type": contentType
            },
            body: imageBuffer
          })
            .then(r => {
              setImageUrl(res.publicUrl, contentType, filename);
              setUploading(false);
            })
            .catch(error => {
              console.error(error);
              setUploading(false);
            });
        });
    });
  } else {
    fetch(
      "https://us-central1-kids-qualitytime.cloudfunctions.net/upload_file/url",
      {
        method: "POST",
        headers: {
          Accept: "application/json"
        },
        body: JSON.stringify({
          filename,
          contentType,
          folder
        })
      }
    )
      .then(res => res.json())
      .then(res => {
        fetch(res.url, {
          method: "PUT",
          headers: {
            "Content-Type": contentType
          },
          body: upFile
        })
          .then(r => {
            setImageUrl(res.publicUrl, contentType, filename);
            setUploading(false);
          })
          .catch(error => {
            console.error(error);
            setUploading(false);
          });
      });
  }
};

const ImageLabel = styled.label`
  transform: scale(1, 1);
  position: relative;
  left: 0;
  top: 0;
  width: 140px;
  height: 110px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  border: 1px solid ${props => props.theme.color4};
  background-color: ${props => props.theme.color1};
  cursor: pointer;
`;

const FileLabel = styled.label`
  transform: scale(1, 1);
  position: relative;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  border: 1px solid ${props => props.theme.color4};
  background-color: ${props => props.theme.color1};
  color: ${props => props.theme.color5};
  cursor: pointer;
  padding: 10px;
  white-space: nowrap;
`;

const ImageLabelText = styled.span`
  color: ${props => props.theme.color5};
  margin-top: 5px;
  font-weight: 700;
`;

const Input = styled.input`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`;

const EditLabel = styled.label`
  position: absolute;
  right: -10px;
  top: -10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Root = styled.div`
  width: 100%;
  max-width: 300px;
  display: flex;
  justify-content: center;
  padding: 5px;
  flex-direction: column;
  position: relative;
  min-height: ${props => (props.notImage ? "0" : "110px")};
  img {
    width: 100%;
  }
`;

export default withTheme(
  ({ folder, image, onUpload, onLoading, notImage, theme, id, addLabel }) => {
    const [imageUrl, setImageUrl] = useState(image ? image : "");
    const [uploading, setUploading] = useState(false);
    if (uploading) {
      return <Loader />;
    }
    const theId = id || "single";
    return (
      <Root notImage={true}>
        <Input
          type="file"
          id={theId}
          onChange={e =>
            onChange(
              v => {
                setUploading(v);
                if (onLoading) {
                  onLoading(v);
                }
              },
              (url, contentType, filename) => {
                setImageUrl(url);
                if (!notImage) {
                  var img = new Image();
                  img.src = url;
                  if (onUpload) {
                    img.onload = function() {
                      var height = img.height;
                      var width = img.width;
                      onUpload(url, width, height, contentType, filename);
                    };
                  }
                } else {
                  if (onUpload) {
                    onUpload(url, 0, 0, contentType, filename);
                  }
                }
              },
              e,
              folder
            )
          }
        />
        {!imageUrl && !notImage && (
          <ImageLabel htmlFor={theId} for={theId}>
            <FontAwesomeIcon
              icon={["fas", "camera"]}
              size="2x"
              color={theme.color5}
            />
            <ImageLabelText>Add a photo</ImageLabelText>
          </ImageLabel>
        )}
        {!imageUrl && notImage && (
          <FileLabel htmlFor={theId} for={theId}>
            {addLabel || "Choose File"}
          </FileLabel>
        )}
        {imageUrl && !notImage && (
          <EditLabel htmlFor={theId} for={theId}>
            <CircularButton icon="pen" disabled />
          </EditLabel>
        )}
        {imageUrl && !notImage && <img src={imageUrl} />}
      </Root>
    );
  }
);
